import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Portfolio render error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          background: '#111',
          color: '#fff',
          textAlign: 'center',
        }}>
          <div>
            <h1 style={{ color: '#fff', marginBottom: '1rem' }}>Something went wrong</h1>
            <p>Please refresh the page. If the issue continues, contact me at aamir2saiyad@gmail.com</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
